import config from '../config';
import { Brands } from '../constants/AppConstants';

export function getBrandInfo() {
    const brand = config.get('brand');
    const isSouthEastern = brand === 'southeastern';
    const isGTR = Object.values(Brands).includes(brand);

    return { brand, isSouthEastern, isGTR };
}



// WEBPACK FOOTER //
// ./src/lib/brand.js